

































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import pagelist from '@/components/pagelistcomponent';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
@Component({ components: {  } })
export default class auditlog extends pagelist {
  get auditproxy() {
    return new proxy.OperatorLogServiceProxy();
  }
  input: proxy.OperatorLogPageInputDto = new proxy.OperatorLogPageInputDto();
  rangdate = [new Date(new Date(new Date().toLocaleDateString()).getTime()), new Date()];
  createOrEditShow = false;
  sub_model: proxy.AuditLogListDto = new proxy.AuditLogListDto();
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center'
    },
    {
      title: '创建时间',
      key: 'createTime'
    },
    {
      title: '类型',
      key: 'operatorLogTypeName'
    },
    {
      title: '操作人',
      key: 'operatorUserName'
    },
    {
      title: '操作内容',
      key: 'operatorContent'
    }
  ];
  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.input.startDate = this.rangdate[0];
    this.input.endDate = this.rangdate[1];
    
    this.auditproxy.queryPageList(this.input).then(x => {
      this.dataList = x.items;
      this.showPaging(x);
    });
  }
  showdetail(row) {
    this.sub_model = proxy.AuditLogListDto.fromJS(row);
    this.createOrEditShow = true;
  }
  getpage() {
    this.OnInit();
  }
  async created() {
    this.getpage();
  }
}
